export const CUSTOM_FIELD_HEADERS = [
  'display_name',
  'display_region',
  'modal_promo_banner_text',
  'display_badge',
  'display_tasting_tags',
  'display_volume',
  'display_alcoholic_content',
  'pack_type',
  'parent_product_sku',
  'standard_drink_count',
  'menu_tile_promo_text',
  'product_image_file',
  'save_text',
  'display_menu_tile',
  'short_description',
  'margin',
  'is_bundle',
  'product_list',
  'brand',
  'algolia_tags',
  'reporting_category_1',
  'reporting_category_2',
  'reporting_category_3',
  'upsell_bundles',
  'upsell_products',
];

export const VALID_HEADERS = [
  'is_visible',
  'name',
  'categories',
  'zones',
  'sku',
  'weight',
  'description',
  'price',
  'cost_price',
  'page_title',
  'meta_description',
  'sort_order',
  'product_image_file',
  'product_image_description',
  ...CUSTOM_FIELD_HEADERS,
];

export const PACK_TYPES = [
  'Can',
  'Bottle',
  '2 Pack',
  '4 Pack',
  '6 Pack',
  '8 Pack',
  '10 Pack',
  '12 Pack',
  '16 Pack',
  '18 Pack',
  '40 Pack',
  '45 Pack',
  'Case',
  'Case (of 16)',
  'Case (of 30)',
  'Bag',
  'Pack',
  'Packet',
  'Tub',
  'Box',
  'Bundle',
];

export const REPORTING_CATEGORIES = [
  {
    name: 'Beer & Cider',
    subcategory: [
      { name: 'Australian' },
      { name: 'International' },
      { name: 'Craft Beer' },
      { name: 'Fruity Beer' },
      { name: 'Ginger Beer' },
      { name: 'Cider' },
      { name: 'Beer Cases' },
    ],
  },
  {
    name: 'Wine',
    subcategory: [
      {
        name: 'White Wine',
        subcategory: [
          { name: 'Chardonnay' },
          { name: 'Sauvignon Blanc' },
          { name: 'Semillon & Blends' },
          { name: 'Riesling' },
          { name: 'Pinot Grigio & Pinot Gris' },
          { name: 'Moscato & Sweet Whites' },
        ],
      },
      {
        name: 'Rose Wine',
      },
      {
        name: 'Red Wine',
        subcategory: [
          { name: 'Shiraz & Blends' },
          { name: 'Cabernet Sauvignon & Blends' },
          { name: 'Merlot & Blends' },
          { name: 'Pinot Noir & Sweet Reds' },
          { name: 'Sangiovese & Grenache' },
          { name: 'Tempranillo & Malbec' },
        ],
      },
      {
        name: 'Sparkling Wine',
        subcategory: [{ name: 'Sparkling White' }, { name: 'Champagne' }, { name: 'Sparkling Rose' }, { name: 'Prosecco & Cava' }],
      },
    ],
  },
  {
    name: 'Spirits',
    subcategory: [
      { name: 'Whisky' },
      { name: 'Bourbon' },
      { name: 'Vodka' },
      { name: 'Gin' },
      { name: 'Tequila' },
      { name: 'Rum' },
      { name: 'Aperitifs & Digestifs' },
      { name: 'Brandy' },
      { name: 'Liqueur' },
    ],
  },
  {
    name: 'Premix',
    subcategory: [
      { name: 'Seltzer' },
      { name: 'Mixed Vodka' },
      { name: 'Mixed Gin' },
      { name: 'Mixed Bourbon' },
      { name: 'Mixed Rum' },
      { name: 'Mixed Whiskey' },
      { name: 'Premixed Cocktails' },
      { name: 'Premix Cases' },
    ],
  },
  { name: 'Non Alcohol' },
  { name: 'Mixers & Ice', subcategory: [{ name: 'Traditional Mixers & Ice' }, { name: 'Cocktail Mixers' }] },
  { name: 'Nibbles & Accessories', subcategory: [{ name: 'Nibbles & Sweets' }, { name: 'Accessories' }] },
  { name: 'Tobacco' },
  { name: 'Cocktail & Bundles' },
  { name: 'Meals & Desserts', subcategory: [{ name: 'Meal & Condiments' }, { name: 'Desserts' }] },
  { name: 'Health & Wellbeing' },
  { name: 'New & Exciting' },
];
